/**
 * The walkthrough's live state, and nothing else (job #850).
 *
 * Split out of useWalkthrough.ts so App.vue can ask "is a walk running?"
 * without importing the compiled pack — 250 kB of walks and Handbook text that
 * used to ride every learner's boot because the overlay was mounted, and so
 * fetched, on every page. App mounts WalkOverlay only while `activeWalk` is
 * set; the pack loads with whichever surface offers a walk (Settings, the
 * Library's How this works, the dashboard), which is the only place a walk
 * can ever be started from.
 */
import { ref, reactive } from 'vue'
import type { Walk } from './useWalkthrough'

export const activeWalk = ref<Walk | null>(null)
export const stepIndex = ref(0)
export const showingTerminal = ref(false)
/** Which way the reader last moved — a skipped step keeps going that way. */
export const lastMove = ref<1 | -1>(1)
/**
 * A Handbook Show me is waiting to be claimed (useWalkthrough.deferWalk).
 * Here, pack-free, so the player can notice one without loading the pack at
 * boot: it imports the engine only when this is true, by which time the
 * Handbook has already loaded it.
 */
export const deferredPending = ref(false)

/**
 * What the page in front of the reader can do, for walks that declare `needs`
 * (job #665). A surface that knows sets its answer — the mode tray says whether
 * this course has Script mode — and a walk needing something the page has said
 * NO to opens as its `unavailable` sentence instead of its steps. A capability
 * nobody has spoken for counts as present: the walk runs as it always did.
 */
export const walkCapabilities = reactive(new Map<string, boolean>())
/** The running walk opened as its `unavailable` sentence: one card, no Back. */
export const walkUnavailable = ref(false)
